import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/sv.ts
var remove = "Ta bort";
var removeAll = "Ta bort alla";
var incomplete = "Tyvärr är inte alla fält korrekt ifyllda";
var submit = "Skicka";
var noFiles = "Ingen fil vald";
var moveUp = "Flytta upp";
var moveDown = "Flytta ner";
var isLoading = "Laddar...";
var loadMore = "Ladda mer";
var next = "Nästa";
var prev = "Föregående";
var addAllValues = "Lägg till alla värden";
var addSelectedValues = "Lägg till valda värden";
var removeAllValues = "Ta bort alla värden";
var removeSelectedValues = "Ta bort valda värden";
var chooseDate = "Välj datum";
var changeDate = "Ändra datum";
var close = "Stäng";
var open = "Öppna";
var accepted = function({
  name
}) {
  return `Var god acceptera ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} måste vara efter ${date(args[0])}.`;
  }
  return `${sentence(name)} måste vara framåt i tiden.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} kan enbart innehålla bokstäver i alfabetet.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} kan bara innehålla bokstäver och siffror.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} kan bara innehålla bokstäver och blanksteg.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} måste innehålla alfabetiska tecken.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} måste innehålla bokstäver eller siffror.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} måste innehålla bokstäver eller mellanslag.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} måste innehålla symbol.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} måste innehålla versaler.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} måste innehålla gemener.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} måste innehålla siffror.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} måste vara en symbol.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} kan bara innehålla versaler.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} kan bara innehålla små bokstäver.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} måste vara före ${date(args[0])}.`;
  }
  return `${sentence(name)} måste vara bakåt i tiden.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Det här fältet ställdes inte in korrekt och kan inte användas.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} måste vara mellan ${a} och ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} matchar inte.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} är inte ett giltigt datum, var god använd formatet ${args[0]}`;
  }
  return "Det här fältet ställdes inte in korrekt och kan inte användas";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} måste vara mellan ${date(args[0])} och ${date(args[1])}`;
};
var email = "Var god fyll i en giltig e-postadress.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} slutar inte med ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} är inte ett godkänt värde.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} måste ha minst ett tecken.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} måste vara ${max2} tecken eller färre.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} bör vara ${max2} tecken långa.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} måste vara ${min2} tecken eller fler.`;
  }
  return `${sentence(name)} måste vara mellan ${min2} och ${max2} tecken.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} är inte ett godkänt värde.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Kan inte ha mer än ${args[0]} ${name}.`;
  }
  return `${sentence(name)} måste vara ${args[0]} eller mindre.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Inga filtyper tillåtna.";
  }
  return `${sentence(name)} måste vara av filtypen: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Kan inte ha mindre än ${args[0]} ${name}.`;
  }
  return `${sentence(name)} måste vara minst ${args[0]}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” är inte ett godkänt ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} måste vara en siffra.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" eller ")} krävs.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} är obligatoriskt.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} börjar inte med ${list(args)}.`;
};
var url = function() {
  return `Ange en giltig URL.`;
};
var invalidDate = "Det valda datumet är ogiltigt.";
var ui = {
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var sv_default = {
  ui,
  validation
};

export { accepted, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, sv_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=sv.mjs.map